const classNamePrefix = 'tenants-edit__'
const halfClassName = `${classNamePrefix}form-group--half`
const inline = {
  inline: true,
}
const hidden = {
  classNames: 'hidden',
  'ui:widget': 'hidden',
}
const fieldDisabled = 'ui:disabled'
const radioOptions = {
  'ui:widget': 'radio',
  'ui:options': inline,
}
const checkboxesOptions = {
  'ui:widget': 'checkboxes',
  'ui:options': inline,
}
const textareaOption = {
  'ui:widget': 'textarea',
}
const order = [
  'acronym',
  'name',
  'description',
  'programName',
  'partOfDigitalHouse',
  'agileReleaseTrain',
  'nebulaControllingInformation',
  'gbsControllingInformation',
  'b2xCoreControllingInformation',
  'awsAccountId',
  'status',
  'disabledPlanningIT',
  'icto',
  'planningItId',
  'confidentiality',
  'integrity',
  'availability',
  'continuity',
  'personalData',
  'docLink',
  'coNumber',
  'experiences',
  'members',
]
const classNames = (str, half) => {
  return half
    ? {
        classNames: `${str} ${halfClassName}`,
      }
    : {
        classNames: str,
      }
}
const dataFormat = function (params) {
  return {
    acronym: params.isCreating
      ? classNames(`${classNamePrefix}acronym hilited`)
      : hidden,
    name: classNames(`${classNamePrefix}name odd`),
    description: {
      ...classNames(`${classNamePrefix}description textarea even`),
      ...textareaOption,
    },
    programName: classNames(`${classNamePrefix}programName even`),
    partOfDigitalHouse: {
      ...classNames(`${classNamePrefix}partOfDigitalHouse even`, false),
      ...radioOptions,
    },
    nebulaControllingInformation: classNames(
      `${classNamePrefix}nebulaControllingInformation odd`,
    ),
    gbsControllingInformation: classNames(
      `${classNamePrefix}gbsControllingInformation even`,
    ),
    b2xCoreControllingInformation: classNames(
      `${classNamePrefix}b2xCoreControllingInformation odd`,
    ),
    status: {
      ...classNames(
        `${classNamePrefix}status odd ${
          !params.isWhitelisted ? 'no-click' : ''
        }`,
        false,
      ),
      ...radioOptions,
    },
    disabledPlanningIT: {
      ...classNames(`${classNamePrefix}disabledPlanningIT odd`, false),
      ...radioOptions,
    },
    docLink: {
      ...classNames(`${classNamePrefix}doclink even`),
      'ui:placeholder': 'http://',
    },
    coNumber: classNames(`${classNamePrefix}name odd`),
    experiences: {
      ...classNames(`${classNamePrefix}experiences even`, false),
      ...checkboxesOptions,
    },
    members: {
      ...classNames(`${classNamePrefix}members odd`),
      items: {
        'ui:order': [
          'roles',
          'email',
          'firstName',
          'lastName',
          'mbioId',
          'daimlerId',
          'tenantMemberUntil',
          'comment',
          'tenant',
        ],
        roles: {
          ...classNames('role-selector'),
        },
        firstName: {},
        lastName: {},
        mbioId: {},
        daimlerId: {},
        tenant: hidden,
        tenantMemberUntil: {
          'ui:widget': 'dateWidget',
          'ui:options': {
            min: params.memberExpiringDateRange.min,
            max: params.memberExpiringDateRange.max,
          },
        },
        comment: {
          ...textareaOption,
          ...classNames('member-comment'),
        },
      },
      'ui:options': {
        orderable: false,
      },
      'ui:help':
        '* Permissions sync times: Jenkins permissions are updated every 10min, PCF permissions are updated every 30min.',
    },
  }
}
const dataFormatHidden = {
  acronym: hidden,
  name: hidden,
  description: hidden,
  status: hidden,
  experiences: hidden,
  docLink: hidden,
  platformAutomation: hidden,
  coNumber: hidden,
  members: hidden,
}
const dataFormatCompliance = {
  disabledPlanningIT: {
    ...classNames(`${classNamePrefix}disabledPlanningIT odd`, false),
    ...radioOptions,
  },
  icto: classNames(`${classNamePrefix}icto odd`, true),
  planningItId: classNames(`${classNamePrefix}planningItId odd`, false),
  confidentiality: {
    ...classNames(`${classNamePrefix}confidentiality odd`, true),
    ...radioOptions,
  },
  integrity: {
    ...classNames(`${classNamePrefix}integrity odd`, true),
    ...radioOptions,
  },
  availability: {
    ...classNames(`${classNamePrefix}availability odd`, true),
    ...radioOptions,
  },
  continuity: {
    ...classNames(`${classNamePrefix}continuity odd`, true),
    ...radioOptions,
  },
  personalData: {
    ...classNames(`${classNamePrefix}personalData odd`, true),
    ...radioOptions,
  },
}

export const uiSchemaFor = function (params) {
  return {
    'ui:order': order,
    ...dataFormat(params),
    ...dataFormatCompliance,
  }
}

export const uiSchemaCompliance = {
  'ui:order': order,
  ...dataFormatHidden,
  ...dataFormatCompliance,
}

export const updateFormUiSchema = function (props, formData) {
  const { memberExpiringDateRange, isCreating, isWhitelisted, userRoles } =
    props
  let { schema, tenantInfo } = props
  let { tenantInfo: tenantData } = props

  if (!schema || !tenantInfo) {
    return null
  }

  initializeMemberComments(tenantInfo.members)

  const uiSchema = generateUiSchema({
    memberExpiringDateRange,
    isCreating,
    isWhitelisted,
  })

  if (formData != null) {
    tenantInfo = formData
  }

  updateExperiencesSection(schema, tenantInfo, uiSchema)

  updateNameField(userRoles, uiSchema)

  updateDisabledPlanningITFields(schema, tenantInfo)

  return { schema, uiSchema, formData: tenantInfo }
}

function initializeMemberComments(members) {
  members.forEach((member) => {
    member.comment ||= ''
  })
}

function generateUiSchema({
  memberExpiringDateRange,
  isCreating,
  isWhitelisted,
}) {
  return uiSchemaFor({ memberExpiringDateRange, isCreating, isWhitelisted })
}

function updateExperiencesSection(schema, tenantInfo, uiSchema) {
  if (schema.properties.experiences) {
    const schemaExperienceItems = schema.properties.experiences.items

    if (
      !schemaExperienceItems.enum ||
      schemaExperienceItems.enum.length === 0
    ) {
      resetEmptyExperienceSection(schemaExperienceItems, uiSchema)
    } else {
      updateValidExperienceList(schemaExperienceItems, tenantInfo)
      toggleExperienceField(tenantInfo, schemaExperienceItems, uiSchema)
    }
  }
}

function resetEmptyExperienceSection(schemaExperienceItems, uiSchema) {
  delete schemaExperienceItems.enum
  delete schemaExperienceItems.enumNames

  uiSchema['experiences'] = {
    classNames: 'hidden',
    'ui:widget': 'checkboxes',
  }

  schemaExperienceItems.minItems = 0
}

function updateValidExperienceList(schemaExperienceItems, tenantInfo) {
  const validExperienceList = tenantInfo.experiences.filter((acronym) =>
    schemaExperienceItems.enum.includes(acronym),
  )

  tenantInfo.experiences = validExperienceList
}

function toggleExperienceField(tenantInfo, schemaExperienceItems, uiSchema) {
  const experienceField = tenantInfo.type?.includes('frontend')
    ? {
        classNames: 'tenants-edit__experiences even',
        'ui:options': { inline: true },
        'ui:widget': 'checkboxes',
      }
    : {
        classNames: 'hidden',
        'ui:widget': 'checkboxes',
      }

  uiSchema['experiences'] = experienceField

  if (schemaExperienceItems) {
    schemaExperienceItems.minItems = tenantInfo.type?.includes('frontend')
      ? 1
      : 0
  }
}

function updateNameField(userRoles, uiSchema) {
  if (!userRoles?.includes('admin')) {
    uiSchema['name'][fieldDisabled] = true
  }
}

function updateDisabledPlanningITFields(schema, tenantInfo) {
  if (schema.properties.disabledPlanningIT) {
    if (tenantInfo.disabledPlanningIT) {
      disablePlanningITFields(schema, tenantInfo)
    } else {
      enablePlanningITFields(schema)
    }
  }
}

function disablePlanningITFields(schema, tenantInfo) {
  const fieldsToDisable = ['icto', 'planningItId']

  fieldsToDisable.forEach((field) => {
    const fieldPath = [field, fieldDisabled]
    tenantInfo[field] = true
    schema[field].uiSchema[fieldPath] = true
  })

  schema.required = schema.required.filter((e) => !fieldsToDisable.includes(e))
}

function enablePlanningITFields(schema) {
  const fieldsToEnable = ['icto', 'planningItId']

  fieldsToEnable.forEach((field) => {
    const fieldPath = [field, fieldDisabled]
    delete schema[field].uiSchema[fieldPath]
  })

  schema.required = [
    ...schema.required,
    ...fieldsToEnable.filter((o) => !schema.required.includes(o)),
  ]
}
